import React from 'react'

// Components
import UserList from './UserList'

function Todo() {
    return (
        <div>
            <UserList />
        </div>
    )
}

export default Todo
